<div *ngIf="globals.currentview == 'login'" class="login-container">

  <div class="main-wrapper" layout-align="center center">

    <mat-card *ngIf="!loginBusy" class="box">

      <div class="card-head">
        <mat-card-header>
          <mat-card-title *ngIf="activeForm == 'loginForm'">
            <img class="logoImage" src="assets/img/LogoTransparent_LigBlou.png">
            <br>
            <div class="h3" style="margin-bottom: 0px;">Sign In</div>
            <div class="ag-body-small-medium"
              style="text-align: center;margin-top: 14px; display: flex; flex-direction: row; justify-content: center; margin-bottom:30px ;">
              <div>Don't Have an account? </div>
              <div class="warnTextColor" style="margin-left: 4px; cursor: pointer;"
                (click)="switchActiveScreen('signup')"> Create Account</div>
            </div>
          </mat-card-title>

          <mat-card-title *ngIf="activeForm == 'signupForm'">
            <img class="logoImage" src="assets/img/LogoTransparent_LigBlou.png">
            <br>
            <div class="h3" style="margin-bottom: 0px;">Create an account</div>
            <div class="ag-body-small-medium"
              style="text-align: center;margin-top: 14px; display: flex; flex-direction: row; justify-content: center; margin-bottom:30px ;">
              <div>Already have an account? </div>
              <div class="warnTextColor" style="margin-left: 4px; cursor: pointer;"
                (click)="switchActiveScreen('signin')">Sign In</div>
            </div>
          </mat-card-title>



        </mat-card-header>
      </div>

      <div *ngIf="activeForm == 'loginForm'">
        <mat-card-content>
          <form class="login-form">
            <mat-form-field class="gate-full-width" appearance="standard" color="accent">
              <mat-label>Email address</mat-label>
              <input type="email" matInput [formControl]="emailFormControl">
              <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                Please enter a valid email address
              </mat-error>
              <mat-error *ngIf="emailFormControl.hasError('required')">
                Email is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="gate-full-width" appearance="standard" color="accent">
              <mat-label>Password</mat-label>
              <input [type]="hidePW1 ? 'password' : 'text'" matInput [formControl]="passwordFormControl" (keydown)="keyDownFunction($event)">
              <mat-icon class="suffix-icon" matSuffix (click)="hidePW1 = !hidePW1">
                {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              <mat-error *ngIf="passwordFormControl.hasError('required')">
                Password is required
              </mat-error>
              <mat-error *ngIf="passwordFormControl.hasError('minlength')">
                Minimum 8 characters
              </mat-error>
            </mat-form-field>
          </form>
          <!-- <br> -->

          <div class="ag-body-medium"
            style="text-align: center;margin-top: 14px; display: flex; flex-direction: row; justify-content: left; margin-bottom:30px ;">
            <div>Forgot Password?</div>
            <div class="warnTextColor" style="margin-left: 4px; cursor: pointer;" (click)="sendRecoveryEmail()"> Reset
              Password</div>
          </div>
        </mat-card-content>

        <button [disabled]="signInDisabled()" mat-raised-button class="btn-block login-button ag-body-medium"
          (click)="doLogin()">Sign
          In</button>

      </div>

      <div *ngIf="activeForm == 'signupForm'">
        <mat-card-content>
          <form class="login-form">

            <span>
              <mat-form-field class="gate-full-width" appearance="standard" color="accent">
                <mat-label>Email address</mat-label>
                <input type="email" matInput [formControl]="emailFormControl">
                <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                  Please enter a valid email address
                </mat-error>
                <mat-error *ngIf="emailFormControl.hasError('required')">
                  Email is required
                </mat-error>
              </mat-form-field>
            </span>

            <span>
              <mat-form-field class="gate-half-width" appearance="standard" color="accent">
                <mat-label>First name</mat-label>
                <input type="text" matInput [formControl]="nameFormControl">
                <mat-error *ngIf="nameFormControl.hasError('required')">
                  Name is required
                </mat-error>
              </mat-form-field>

              <mat-form-field class="gate-half-width" appearance="standard" color="accent" style="float: right;">
                <mat-label>Last name (optional)</mat-label>
                <input type="text" matInput [formControl]="surnameFormControl">


              </mat-form-field>

            </span>

            <span>


              <mat-form-field class="gate-full-width" appearance="standard" color="accent" style="float: right;">
                <mat-label>Phone Number (optional)</mat-label>
                <input type="tel" matInput [formControl]="phoneFormControl" placeholder="060 779 2177">

              </mat-form-field>
            </span>

            <span>
              <mat-form-field class="gate-full-width" color="accent" appearance="standard">
                <mat-label>Password</mat-label>
                <input [type]="hidePW2 ? 'password' : 'text'" matInput [formControl]="passwordFormControl">
                <mat-icon class="suffix-icon" matSuffix (click)="hidePW2 = !hidePW2">
                  {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                <mat-error *ngIf="passwordFormControl.hasError('required')">
                  Password is required
                </mat-error>
                <mat-error *ngIf="passwordFormControl.hasError('minlength')">
                  Minimum 8 characters
                </mat-error>
              </mat-form-field>



            </span>


            <span>
              <mat-form-field class="gate-full-width" appearance="standard" color="accent" style="float: right;">
                <mat-label>Password</mat-label>
                <input [type]="hidePW3 ? 'password' : 'text'" matInput [formControl]="passwordRetypeFormControl">
                <mat-icon class="suffix-icon" matSuffix (click)="hidePW3 = !hidePW3">
                  {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                <mat-error *ngIf="passwordRetypeFormControl.hasError('required')">
                  Password is required
                </mat-error>
                <mat-error *ngIf="passwordRetypeFormControl.hasError('minlength')">
                  Minimum 8 characters
                </mat-error>
                <mat-error
                  *ngIf="passwordRetypeFormControl.hasError('pattern') && !passwordRetypeFormControl.hasError('minlength')">
                  Passwords do not match
                </mat-error>
              </mat-form-field>
            </span>

            <!-- <span> -->
            <mat-checkbox id="checkboxTandC" style="margin-bottom: 30px; flex-direction: row;" checked=true>



              <div class="ag-body-extra-small dark-2">
                <span (mousedown)="$event.stopPropagation()" (click)="selectCheckText($event)">
                  <div>By clicking Create account, I agree
                    that I have read and accepted
                    <br>the <span class="warnTextColor pointer" (click)="showTsAndCs()">Terms of Use</span> and <span
                      class="warnTextColor pointer" (click)="showPrivacyPolicy()">Privacy Policy</span>.</div>
                </span>
              </div>
            </mat-checkbox>
            <!-- </span> -->
          </form>

        </mat-card-content>



        <button [disabled]="signUpDisabled()" mat-raised-button color="primary" class="btn-block login-button"
          (click)="doSignup()">Create Account</button>




      </div>

    </mat-card>

    <mat-progress-spinner *ngIf="loginBusy" class="example-margin" color="primary" mode="indeterminate">
    </mat-progress-spinner>

  </div>
</div>

<app-nav *ngIf="globals.currentview == 'app'" class="main-container"></app-nav>

<div *ngIf="globals.currentview == 'loading'" class="login-container">
  <mat-progress-spinner mode="indeterminate">
  </mat-progress-spinner>
</div>
